import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const images = ['https://cdn.magicpatterns.com/uploads/smdewtMFdorTEwRWbTrRWZ/rosi_3.png', 'https://cdn.magicpatterns.com/uploads/4rYcggexNx8PZBzLBdDn7B/rosi_11.png', 'https://cdn.magicpatterns.com/uploads/pDc5iGNwAuzaLMRciyFnPC/rosi_10.png', 'https://cdn.magicpatterns.com/uploads/1AEmrBuZ7eR4puGGueXsG3/rosi11.png', 'https://cdn.magicpatterns.com/uploads/6CFMVcRx8vVYT8gdnPfHPL/rosi_4.png', 'https://cdn.magicpatterns.com/uploads/5ALyoy1z4qLaLuR8Qi9f7E/rosi14.png', 'https://cdn.magicpatterns.com/uploads/nubHVq6WAsB5kiDRiUSzKW/rosi_9.png', 'https://cdn.magicpatterns.com/uploads/45hM63CJA6quoyYVfEPiz4/rosi_13.png', 'https://cdn.magicpatterns.com/uploads/czcBwPgi1icLra8TRntaBg/rosi_2.png', 'https://cdn.magicpatterns.com/uploads/7qUj6b8f9tV8UnmkRsX1v1/rosi15.png', 'https://cdn.magicpatterns.com/uploads/jArPWYopEg2isWbgv5bsB3/rosi_8.png', 'https://cdn.magicpatterns.com/uploads/dWbKJewZSjZ6GBSrXbgJZV/rosi_6.png', 'https://cdn.magicpatterns.com/uploads/xjFxM7WniZBNBURQLbeX6D/rosi.png', 'https://cdn.magicpatterns.com/uploads/pHKnnfJLLH4xPXTfALtTUA/rosi_5.png', 'https://cdn.magicpatterns.com/uploads/ihycbBv8r2kMCmfd2K5XhV/rosi_1.png'];
// Duplicate the array so the marquee loops seamlessly
const marqueeImages = [...images, ...images];
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="galeria" className="pt-10 md:pt-14 pb-16 md:pb-20 bg-riam-black overflow-hidden scroll-mt-24" data-id="element-94">
      <div className="container mx-auto px-4 md:px-6 mb-10" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-96">
          <p className="gold-shine-soft font-script font-semibold italic text-lg md:text-xl tracking-widest uppercase mb-3" data-id="element-97">
            {t.gallery.subtitle}
          </p>
          <h2 className="gold-shine font-script font-semibold text-4xl md:text-5xl lg:text-6xl mb-3 tracking-tight" data-id="element-98">
            {t.gallery.title1}
            <span className="font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle ml-1" data-id="element-99">
              {t.gallery.titleHighlight}
            </span>
          </h2>
          <div className="gold-divider mx-auto w-32 mt-5" data-id="element-100" />

          {/* Instagram CTA */}
          <motion.a href="https://www.instagram.com/riam_beautystudio/" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-3 mt-8 px-6 py-3 rounded-full border border-riam-gold/40 bg-riam-jet/60 backdrop-blur-sm hover:border-riam-gold transition-all duration-300 hover:shadow-[0_0_30px_rgba(224,193,121,0.25)] group" aria-label="Síguenos en Instagram @riam_beautystudio" data-id="element-101">
            <Instagram size={20} stroke="url(#riamGold)" className="icon-glow group-hover:icon-glow-strong transition-all" data-id="element-102" />
            <span className="gold-shine font-sans text-xs md:text-sm font-semibold tracking-[0.25em] uppercase" data-id="element-103">
              {t.gallery.followUs}
            </span>
            <span className="font-allura text-2xl md:text-3xl text-riam-gold leading-none" data-id="element-104">
              @riam_beautystudio
            </span>
          </motion.a>
        </motion.div>
      </div>

      {/* Edge fade overlays for cinematic feel */}
      <div className="relative" data-id="element-105">
        <div className="absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-riam-black to-transparent z-10 pointer-events-none" data-id="element-106" />
        <div className="absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-riam-black to-transparent z-10 pointer-events-none" data-id="element-107" />

        {/* Marquee track */}
        <div className="gallery-marquee flex gap-6 md:gap-8" data-id="element-108">
          {marqueeImages.map((src, i) => <div key={i} className="gallery-card relative flex-shrink-0 w-[260px] sm:w-[300px] md:w-[340px] aspect-[3/4] rounded-sm overflow-hidden group" data-id="element-109">
              {/* Animated gold gradient border */}
              <div className="gallery-card-border" aria-hidden="true" data-id="element-110" />

              <img src={src} alt={`Transformación Riam Beauty Studio ${i % images.length + 1}`} className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" loading="lazy" draggable={false} data-id="element-111" />

              {/* Subtle bottom gradient + branding */}
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-riam-black/80 via-riam-black/30 to-transparent pointer-events-none" data-id="element-112" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between" data-id="element-113">
                <span className="gold-shine-soft font-allura text-2xl md:text-3xl leading-none" data-id="element-114">
                  Riam
                </span>
                <span className="gold-shine-soft opacity-60 font-sans text-[0.6rem] md:text-[0.65rem] tracking-[0.3em] uppercase mt-1" data-id="element-115">
                  Beauty Studio
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}